module.exports = __webpack_public_path__ + "img/img15.f31a8e30.svg";